// CurrencyDescription組件翻譯
export default {
  // 多幣種畫布說明
  multi: {
    description:
      "多幣種畫布提供更高的自由度，專為複雜分析場景設計，支持在同一畫布中同時分析多鏈、多幣種的地址和交易數據。",
    supportData: "支持數據",
    supportDetails:
      "Ethereum、BSC鏈的全幣種數據，可通過代幣合約精準搜索目標幣種。Tron鏈支持TRX、USDT。",
  },

  // 單幣種畫布說明
  single: {
    description:
      "單幣種畫布操作便捷高效，專注於單一鏈上的單一幣種分析，支持一鍵生成Xmind文件。",
    supportData: "支持數據",
    supportDetails:
      "Ethereum、BSC鏈的全幣種數據，可通過代幣合約精準搜索目標幣種。Tron鏈支持TRX、USDT。BITCOIN鏈僅支持BTC。",
  },
};
